export default __webpack_public_path__ + "static/media/gallery_03.ec539443.jpg";